module.exports = __webpack_public_path__ + "76bf3ade29382b591ee6b8aa5f46ea6b.svg";